import React from 'react';
import styled from 'styled-components';
import zIndex from '../../../theme/shared/zIndex';
import crLogo from './assets/cr-logo.svg';
import srLogo from './assets/sr-logo.svg';
var Image = styled.img.withConfig({
  displayName: "Logo__Image",
  componentId: "sc-18yiye8-0"
})(["object-fit:cover;width:auto;display:block;height:auto;"]);
/**
 * Logo wrapper
 */

var LogoWrapper = styled.div.withConfig({
  displayName: "Logo__LogoWrapper",
  componentId: "sc-18yiye8-1"
})(["display:inline-block;", " width:", ";height:", ";transform:", ";@media ", "{width:", ";height:", ";}"], zIndex('high'), function (props) {
  return props.sizeSm;
}, function (props) {
  return props.sizeSm;
}, function (props) {
  return props.rotate ? 'rotate(-14deg)' : 'inherit';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint('nav');
}, function (props) {
  return props.sizeMd;
}, function (props) {
  return props.sizeMd;
});

var Logo = function Logo(_ref2) {
  var rotate = _ref2.rotate,
      sizeSm = _ref2.sizeSm,
      sizeMd = _ref2.sizeMd,
      campaign = _ref2.campaign;
  return React.createElement(LogoWrapper, {
    rotate: rotate ? 1 : 0,
    sizeSm: sizeSm,
    sizeMd: sizeMd
  }, React.createElement(Image, {
    src: campaign === 'Comic Relief' ? crLogo : srLogo,
    alt: campaign === 'Comic Relief' ? 'Comic Relief logo' : 'Sport Relief logo'
  }));
};

Logo.defaultProps = {
  rotate: false,
  sizeSm: '50px',
  sizeMd: '60px',
  campaign: 'Comic Relief'
};
export default Logo;